/**
 * CR-7714 FE-20: shown when the dashboard could not read any performance
 * settings. The figures still load, but there are no targets or grade bands
 * to judge them against, and none are invented; this says why the colours
 * and target lines are missing.
 */
import { Info } from 'lucide-react';

export const TARGETS_UNAVAILABLE_TEXT =
  'The performance targets could not be loaded, so figures are shown without target colours, grades or target lines. Reload the page; if this stays, check Admin Setup → Performance.';

export function TargetsUnavailableNote({ show }: { show: boolean }) {
  if (!show) return null;
  return (
    <div
      role="status"
      data-testid="targets-unavailable-note"
      className="mb-3 flex items-start gap-2 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-900 dark:border-amber-900 dark:bg-amber-950 dark:text-amber-100"
    >
      <Info className="mt-0.5 h-4 w-4 flex-shrink-0" aria-hidden="true" />
      <p>{TARGETS_UNAVAILABLE_TEXT}</p>
    </div>
  );
}
